// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__EnzY2","main":"Modal_main__aChKD","footer":"Modal_footer__yhbUV","footer_space":"Modal_footer_space__8dvDx","footer_count":"Modal_footer_count__cSxwT"};